import { ThemeNames } from '@/themes'
import { IllustrationMap } from './types'
import { onventisIllustrations } from '@/themes/illustrations/onventis'
import { enpalIllustrations } from '@/themes/illustrations/enpal'
import { ExpiredErrorIcon } from '../Icons/ErrorIcons/ExpiredErrorIcon'
import { AlreadyEndedErrorIcon } from '../Icons/ErrorIcons/AlreadyEndedErrorIcon'
import { CancelledErrorIcon } from '../Icons/ErrorIcons/CancelledErrorIcon'
import { AlreadyUsedErrorIcon } from '../Icons/ErrorIcons/AlreadyUsedErrorIcon'
import { BrowserNotSupportedError } from '../Icons/ErrorIcons/BrowserNotSupportedError'
import { PinIntroIcon } from '../Icons/SwitchToMobileIcons/PinIntroIcon'
import { DeviceSwitchedIcon } from '../Icons/SwitchToMobileIcons/DeviceSwitchedIcon'
import { DeviceNotSwitchedIcon } from '../Icons/SwitchToMobileIcons/DeviceNotSwitchedIcon'
import { SwitchToMobileIcon } from '../Icons/SwitchToMobileIcons/SwitchToMobileIcon'
import { IdentityVerificationIcon } from '../Icons/IdentityVerificationIcon'
import { ErrorIcon } from '../Icons/ErrorIcons/ErrorIcon'
import { SignDocumentIcon } from '../Icons/SignDocumentIcon'
import { PendingSignatoriesIcon } from '../Icons/PendingSignatoriesIcon'
import { SuccessIcon } from '../Icons/SuccessIcon'
import { IdentityVerificationFailedIcon } from '../Icons/IdentityVerificationFailedIcon'
import { HeartIcon } from '../Icons/HeartIcon'
import { SignDocumentSuccessIcon } from '../Icons/SignDocumentSuccessIcon'
import { MediaPermissionsCheckerInitIcon } from '../Icons/MediaPermissionsCheckerIcons/MediaPermissionsCheckerInitIcon'
import { MediaPermissionsCheckerArrowIcon } from '../Icons/MediaPermissionsCheckerIcons/MediaPermissionCheckerArrowIcon'
import { AndroidPadlockErrorIcon } from '../Icons/MediaPermissionsCheckerIcons/AndroidPadlockErrorIcon'
import { AndroidSettingsErrorIcon } from '../Icons/MediaPermissionsCheckerIcons/AndroidSettingsErrorIcon'
import { AndroidShieldErrorIcon } from '../Icons/MediaPermissionsCheckerIcons/AndroidShieldErrorIcon'
import { DesktopPadlockErrorIcon } from '../Icons/MediaPermissionsCheckerIcons/DesktopPadlockErrorIcon'
import { DesktopSettingsErrorIcon } from '../Icons/MediaPermissionsCheckerIcons/DesktopSettingsErrorIcon'
import { MediaPermissionsCheckerErrorIcon } from '../Icons/MediaPermissionsCheckerIcons/MediaPermissionCheckerErrorIcon'
import { elavonIllustrations } from '@/themes/illustrations/elavon'
import { ikanoIllustrations } from '@/themes/illustrations/ikano'
import { AgeVerificationIcon } from '../Icons/AgeVerificationIcon'
import { PasskeyIcon } from '../Icons/PasskeyIcon'

export const defaultIllustrations: IllustrationMap = {
  success: SuccessIcon,
  error: ErrorIcon,
  'transaction-expired': ExpiredErrorIcon,
  'session-expired': ExpiredErrorIcon,
  'transaction-already-ended': AlreadyEndedErrorIcon,
  'transaction-cancelled': CancelledErrorIcon,
  'browser-not-supported': BrowserNotSupportedError,
  'already-used': AlreadyUsedErrorIcon,
  'not-found': ErrorIcon,
  heart: HeartIcon,
  'pin-intro': PinIntroIcon,
  'device-switched': DeviceSwitchedIcon,
  'device-not-switched': DeviceNotSwitchedIcon,
  'switch-to-mobile': SwitchToMobileIcon,
  'identity-verification': IdentityVerificationIcon,
  'identity-verification-failed': IdentityVerificationFailedIcon,
  'age-verification': AgeVerificationIcon,
  passkey: PasskeyIcon,
  'pending-signatories': PendingSignatoriesIcon,
  'sign-document': SignDocumentIcon,
  'sign-document-success': SignDocumentSuccessIcon,
  'media-permissions-checker-init': MediaPermissionsCheckerInitIcon,
  'media-permissions-checker-arrow': MediaPermissionsCheckerArrowIcon,
  'android-padlock-error': AndroidPadlockErrorIcon,
  'android-settings-error': AndroidSettingsErrorIcon,
  'android-shield-error': AndroidShieldErrorIcon,
  'desktop-padlock-error': DesktopPadlockErrorIcon,
  'desktop-settings-error': DesktopSettingsErrorIcon,
  'media-permissions-checker-error': MediaPermissionsCheckerErrorIcon,
}

export const themeOverrides: Partial<Record<ThemeNames, Partial<IllustrationMap>>> = {
  onventisTheme: onventisIllustrations,
  enpalTheme: enpalIllustrations,
  elavonTheme: elavonIllustrations,
  ikanoTheme: ikanoIllustrations,
  ikanoFleksTheme: ikanoIllustrations,
}
